import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';
import { Skeleton } from '../Skeleton';
import GameResultsCircuit from './GameResultsCircuit';
import styles from '../../styles/game/GameResultsScreen.module.css';

const STAT_LABELS = ['Partite giocate', '% vittorie', 'Serie in corso', 'Serie più lunga'];

export default function GameResultsScreen({
  result, gameConfig, stats, statsLoading, statsError, onRetry,
  onArchive, archiveLinkProps, onLella, onCircuitGame, circuitLinkProps,
}) {
  const GameIcon = gameConfig.icon;
  const percentage = stats?.win_percentage == null ? '—' : stats.win_percentage.toLocaleString('it-IT');
  const statValues = stats ? [
    stats.puzzles_played.toLocaleString('it-IT'), percentage,
    stats.current_streak.toLocaleString('it-IT'), stats.longest_streak.toLocaleString('it-IT'),
  ] : [];
  return (
    <div className={styles.results}>
      <p className={styles.summary}>{result.summary}</p>
      <div className={styles.emojis} aria-label="Il tuo risultato">{result.emojis}</div>
      <section aria-label="Le statistiche" className={styles.statistics} aria-busy={statsLoading}>
        <h3>Le statistiche</h3>
        {statsLoading || (!statsError && stats) ? (
          <dl className={styles.statsGrid} role={statsLoading ? 'status' : undefined}
            aria-label={statsLoading ? 'Caricamento statistiche' : undefined}>
            {STAT_LABELS.map((label, index) => (
              <div key={label} aria-hidden={statsLoading || undefined}>
                <dt>{label}</dt>
                <dd>{statsLoading ? <Skeleton width="60%" height="1.2em" className={styles.statValueSkeleton} /> : statValues[index]}</dd>
              </div>
            ))}
          </dl>
        ) : statsError ? (
          <div role="status">
            <p>Non è stato possibile caricare le statistiche.</p>
            <Button onClick={onRetry}>Riprova</Button>
          </div>
        ) : null}
      </section>
      <div className={styles.actions}>
        <Link to={`/${gameConfig.pathName}/archivio`} className={styles.actionBlock} onClick={onArchive} {...archiveLinkProps}>
          <span className={styles.actionIcon} style={{ backgroundColor: gameConfig.backgroundColor }} aria-hidden="true">
            {GameIcon && <GameIcon size={36} renderMode="solid" />}
          </span>
          <span className={styles.actionText}>
            Ti è piaciuto {gameConfig.displayName}? <span className={styles.actionLink}>Esplora l’archivio</span> <span aria-hidden="true">➡️</span>
          </span>
        </Link>
        {gameConfig.id !== 'ortografia' && (
          <button type="button" className={`${styles.actionBlock} ${styles.lellaBlock}`} onClick={onLella}>
            <span className={`${styles.actionIcon} ${styles.lellaIcon}`} aria-hidden="true">
              <img src="/lella.png" alt="" />
            </span>
            <span className={styles.actionText}>
              Hai una domanda? <span className={styles.actionLink}>Torna al gioco</span> e chiedi a Lella.
            </span>
          </button>
        )}
      </div>
      <GameResultsCircuit currentGame={gameConfig.id} onGameClick={onCircuitGame} linkProps={circuitLinkProps} />
    </div>
  );
}
